import { Component } from '@angular/core';

@Component({
  selector: 'app-fifo-expiry',
  standalone: false,
  
  templateUrl: './fifo-expiry.component.html',
  styles: ``
})
export class FifoExpiryComponent {

}
